import { reactive } from 'vue'

export const store = reactive({
  activeSubmenu: null,
  activeToggle: null,
  inactiveToggle: null,
  searchLabelVacancies: 'Zoek in vacatures',
  searchLabelCourses: 'Zoek in opleidingen',
  searchTerm: null,
  archiveCourseSlug: 'opleidingen',
  teamTeaserFallbackImage: 'images/placeholder.png',
  endpoints: {
    course: '/wp-json/wp/v2/course',
    news: '/wp-json/wp/v2/news',
    story: '/wp-json/wp/v2/story',
    team: '/wp-json/wp/v2/team',
    vacancy: '/wp-json/wp/v2/vacancy'
  },
  filterLabels: {
    'job-type': 'In welk vakgebied wil je werken?',
    'employment-type': 'Wat voor werk zoek je?',
    'weekly-hours': 'Hoeveel uur wil je werken?',
    'education': 'Welke opleiding(en) heb je behaald?'
  }
})